export default __webpack_public_path__ + "static/media/226.57d7177e.jpg";